import { Link } from 'react-router-dom';
import { channels } from '@/mocks/channels';
import { resolveTone, toneStyles } from '@/utils/tone';

export default function NavOverview() {
  return (
    <section id="channels" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-list-check-2" aria-hidden="true" />
              频道列表
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              导航栏结构：十个频道，覆盖你关心的每个领域
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              每个频道都有独立的选题标准与更新节奏，点击即可进入频道列表页查看完整介绍、覆盖范围与代表性内容方向。
            </p>
          </div>
          <Link
            to="/channels"
            className="inline-flex w-fit items-center gap-2 border border-foreground-950/15 hover:border-primary-400 hover:text-primary-600 text-foreground-800 font-label text-sm px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
          >
            全部频道
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {channels.map((channel) => {
            const tone = toneStyles[resolveTone(channel.tone)];
            return (
              <Link
                key={channel.slug}
                to="/channels"
                className={`group flex flex-col gap-3 rounded-lg border border-background-300/60 bg-background-100/50 p-5 transition-colors ${tone.hoverBorder}`}
              >
                <span className={`w-11 h-11 rounded-lg flex items-center justify-center ${tone.iconBox}`}>
                  <i className={`${channel.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{channel.name}</h3>
                <p className="text-xs md:text-sm leading-relaxed text-foreground-600">{channel.summary}</p>
                <div className="mt-auto pt-3 flex items-center justify-between text-xs font-label text-foreground-500">
                  <span>{channel.cadence}</span>
                  <span className="flex items-center gap-1 group-hover:text-primary-600 transition-colors">
                    {channel.volume} 篇
                    <i className="ri-arrow-right-up-line" aria-hidden="true" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}